import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { addPageAction } from '@nike/ux-tread-new-relic';
import { eventNameLookup } from './constants';

/**
 * @private
 * @typedef TrackEventDefaultOptions
 * @property {boolean} usePageAction - denotes whether trackEvent call should also include addPageAction call for an event
 * @property {object|null} telemetryData - optional argument used to trim down select properties to capture for operational telemetry
 */
var defaultOptions = {
  // NOTE since we favor sending telemetry data for most events this helps us both make progress on ui code
  usePageAction: true,
  // usePageEvent? TBD if they determine we have to fire pageEvents we need to abstract that here maybe while using window?.webShellClient?.analytics?.track including changing shape for some things
  // Sometimes we might want to not include whole objects for event data and might want stripped down information (eg activating experiments json).
  // This below option would allow us to define in telemetry data as needed.
  telemetryData: null
};

/**
 * trackEvent is an abstraction that limits the variation of how we would track events across nike-shop.
 * It also ensures default telemetry data to be included with ease
 * and provides a way to only do select telemetry data for the purposes of ops vs unhelpful arbitrary json structures
 *
 * @private
 * @param {string} eventName - event name to send to both
 * @param {object} eventData - event data which is mapped to properties today
 * @param {*} [options={ usePageAction: true, telemetryData: null, $schema: null }] - named params for options available to this function
 */
var trackEvent = function trackEvent(eventName, eventData) {
  var _window;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions,
    usePageAction = _ref.usePageAction,
    telemetryData = _ref.telemetryData,
    $schema = _ref.$schema;
  var track = (_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 || (_window = _window.analytics) === null || _window === void 0 ? void 0 : _window.track;

  // NOTE jest.fn() yields typeof function but NOT instanceof Function
  if (typeof track === 'function' && eventData) {
    // the check for eventData would:
    // a) ensure we never send empty properties
    // b) allow us to bypass calling track if we only need to capture telemetry data but requires passing `null` as 2nd param
    track(eventName, eventData, {
      $schema: $schema || eventNameLookup[eventName],
      writeKey: process.env.SEGMENT_WRITE_KEY
    });
  }
  if (usePageAction) {
    var finalEventData = eventData || {}; // in case we passed null on purpose or is falsy accidentally since we spread this below
    if (telemetryData) {
      finalEventData = telemetryData;
    }
    addPageAction(eventName, _objectSpread(_objectSpread({}, finalEventData), {}, {
      // NOTE removed url because newrelic already is capturing `pageUrl` for us without us doing anything
      version: window.NikeShop.version
    }));
  }
};
export default trackEvent;

// NOTE  if/when we need to implement shell.analytics we can just alter this file at that point to prevent chasing down everything.. for nikeShop